import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Input, Form, message, Image, Avatar, Col, Modal } from 'antd';
import { URL } from '../../../config/api';
import { useDispatch } from 'react-redux';
import { disableSpinner, enableSpinner } from '../../../redux/actions/appActions';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Link, useHistory } from "react-router-dom";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
        >
          <Input style={{width: '60px'}} />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const ExampleCard = () => {
  const [results, setResults] = useState([]);

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');
  const history = useHistory();

  useEffect(() => {
    loadResults();
  }, []);

  const loadResults = async () => {
    try {
      const res = await axios.get(`${URL}/font/get_font.php?load_all=1`);
      if(res.data) {
        const data = res.data;
        data.forEach((item, index) => {
          item.key = index
        });
        setResults(data);
      }else {
        alert("Loading failed.");
      }
    }catch(error) {
      console.log(error);

    }
  }

  const openLinkDetail = (link, payment) => {
    history.push('/link-detail/' + link.Id, {name: link.Name, payment: payment});
  }

  const columns = [
    {
      title: 'Link',
      dataIndex: 'Name',
      key: 'Name',
    },
    {
      title: 'Downloads',
      dataIndex: 'Downloads',
      key: 'Downloads',
    },
  ]

  return (
    <Col span={24}>
      <Card>
        <CardBody>
          <Form form={form} component={false}>
            <Table 
              components={{
                body: {
                  cell: EditableCell
                }
              }}
              columns={columns} 
              dataSource={results} />
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
}



export default ExampleCard;
